import { makeStyles } from "@material-ui/core/styles";

export const BidderStatusSelectStyles = makeStyles(theme => ({
  formControl: {
    width: "100%",
    top: "0",
    marginTop: "0",
  },
}));
